import { useQuery } from "@tanstack/react-query";
import { from, unwrap } from "@vixio/data";
import type { AlertView } from "./api";

/** Dados dos painéis do Início: ficam fora das telas para que elas carreguem sob demanda. */
export function useAlerts(orgId: string) {
  return useQuery({ queryKey: ["alerts", "list", orgId], queryFn: () => unwrap<AlertView[]>(from("alerts", "v_alerts").select("*").eq("org_id", orgId).order("raised_at", { ascending: false }).limit(500)) });
}
